import { useCallback } from 'react';

import { cn } from '@lyearn/style';
import { BaseIconButton, Box } from '@lyearn/ui';

import { COLOR_PICKER_LIST_CONFIG } from '../../consts';
import { colorPickerItemHoverStyles } from './styles';
import { ColorPickerListItemProps, ColorPickerListProps } from './types';

const ColorPickerListItem = (props: ColorPickerListItemProps) => {
  const { config, isSelected, onChange } = props;

  const onClick = useCallback(() => {
    onChange(config.color);
  }, [config.color, onChange]);

  return (
    <BaseIconButton
      className={
        isSelected
          ? 'border-2 border-solid p-2 hover:bg-transparent'
          : cn('p-4', colorPickerItemHoverStyles(config.hover))
      }
      style={isSelected ? { borderColor: config.color } : undefined}
      onClick={onClick}>
      <Box className="h-26 w-26 rounded-full" style={{ background: config.color }} />
    </BaseIconButton>
  );
};

const ColorPickerList = (props: ColorPickerListProps) => {
  const { colors = COLOR_PICKER_LIST_CONFIG, value, onChange } = props;

  return (
    <>
      {colors.map((config) => (
        <ColorPickerListItem
          key={config.color}
          config={config}
          isSelected={value === config.color}
          onChange={onChange}
        />
      ))}
    </>
  );
};

export default ColorPickerList;
